(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function getScrollKey() {
    return 'scroll:' + location.pathname + location.search;
  }

  // Check if we should hide content
  var navEntries = performance.getEntriesByType('navigation');
  var navType = navEntries.length ? navEntries[0].type : null;
  var savedPosition = sessionStorage.getItem(getScrollKey());

  if ((navType === 'back_forward') && savedPosition !== null) {
    document.documentElement.classList.add('restoring-scroll');
  }

  // Save scroll
  var scrollTimeout;
  window.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      sessionStorage.setItem(getScrollKey(), window.pageYOffset);
    }, 100);
  });

  // Restore scroll
  function restoreScrollPosition() {
    var savedPosition = sessionStorage.getItem(getScrollKey());
    if (savedPosition !== null) {
      window.scrollTo(0, parseInt(savedPosition, 10));
      requestAnimationFrame(function () {
        document.documentElement.classList.remove('restoring-scroll');
      });
    } else {
      document.documentElement.classList.remove('restoring-scroll');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var navEntries = performance.getEntriesByType('navigation');
    var navType = navEntries.length ? navEntries[0].type : null;
    
    if (navType === 'back_forward') {
      restoreScrollPosition();
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      restoreScrollPosition();
    }
  });
})();